import React from 'react'
import styled from 'styled-components'
import {AiFillTwitterCircle, AiFillGithub} from 'react-icons/ai'
import {GrMail} from 'react-icons/gr'

const Contact = () => {
    const [loading, setLoading] = React.useState(false)

    const handleLoading = () => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }

  return (
    <StyledContact id="contact">
        <div className="contact-container">
            <div className="text-area">
                <h1>GET IN TOUCH</h1>
            </div>

            <div className="contact-text">
                <p>Do you have a project you want us to work on? contact me</p>
            </div>

            <div className="bioDataBox">
                <div className="icon-container">
                    <div className="contact-icon">
                        <a href="https://twitter.com/tuasegun">
                        <AiFillTwitterCircle/>
                        </a>
                    </div>
                    <div className="contact-icon">
                        <a href="https://github.com/tuasegun">
                        <AiFillGithub/>
                        </a>
                    </div>
                    <div className="contact-icon">
                        <a href="mailto:tuase360@gmail.com">
                        <GrMail/>
                        </a>
                    </div>
                </div>

                <div className="download-button" onClick={handleLoading}>
                    <a href="https://docs.google.com/document/d/10jg6xr3T6g36uGmsfCir0Xd35DFjfRvB49OUxGZcXo4/edit?usp=sharing" rel="noreferrer"  target="_blank">
                        {loading ? <p>Downloading....</p> : <p>Download Resume</p>}
                    </a>
                </div>
            </div>
        </div>
    </StyledContact>
  )
}

export default Contact

const StyledContact = styled.div`
    background-color: #FFF5FF;
    padding: 15.625rem 10% 10.1875rem 10%;

    @media( max-width: 768px){
        padding: 10rem 5%;
    }

    .contact-container{
        .text-area{
            display: flex;
            justify-content: center;
            align-items: center;
            h1{
                text-align: center;
                font-family: 'Space Grotesk';
                font-weight: 500;
                font-size: 7.5rem;
                color: #333333;
                @media (max-width: 768px){
                    font-size: 3.125rem;
                }
            }
        }
        .contact-text{
            display: flex;
            justify-content: center;
            align-items: center; 
            margin-top: 4.25rem;
            @media( max-width: 768px){
                margin-top: 2.1875rem;
            }
            p{
                font-family: 'Nunito', Courier, monospace;
                font-size: 2.5rem;
                line-height: 3.375rem;
                text-align: center;
                @media( max-width: 768px){
                    font-size: 1.25rem;
                    line-height: 1.6875rem;
                }
            }
        }
        .bioDataBox{
            background-color: #FFFFFF;
            padding: 3.9375rem 12% 2.6875rem 12%;
            margin-top: 3.125rem;

            .icon-container{
                display: flex;
                padding-bottom: 3.3125rem;
                justify-content: center;
                align-items: center;
                column-gap: 2.890625rem;
                border-bottom: 2px solid #000000;
                @media( max-width: 768px){
                    padding-bottom: 2rem;
                    column-gap: 1.875rem;
                }
                .contact-icon{
                    font-size: 3rem;
                    a{
                        text-decoration: none;
                        color: #000000;
                    }
                    @media( max-width: 768px){
                        font-size: 1.5rem;
                    }
                }
            }
            .download-button{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 3.125rem;

                    @media (max-width: 768px)  {
                        margin-top: 1.875rem;
                    }

                    a{
                        padding: 2.3125rem 8.5625rem;
                        background-color: #000000;
                        color: #FFFFFF;
                        text-decoration: none;
                        font-size: 1.25rem;
                        line-height: 1.5625rem;
                        font-family: 'Space Grotesk';
                        border: 4px solid #FFFFFF;
                        box-shadow: 21px 18px 0px 0px rgba(130,130,130,0.77);
                        -webkit-box-shadow: 21px 18px 0px 0px rgba(130,130,130,0.77);
                        -moz-box-shadow: 21px 18px 0px 0px rgba(130,130,130,0.77);

                        @media (max-width: 768px)  {
                            padding: 1rem 2.5625rem;
                            font-size: 0.9rem;
                        }
                    }
            }
        } 
    }
`